import { filter, find, map, orderBy, remove, uniq } from 'lodash'

const resolvePackageOptionsObject = () => {
  if (window.pageData.catalogDetails !== undefined) {
    return window.pageData.catalogDetails.packageOptions
  } else if (window.pageData.catalogMix !== undefined) {
    return window.pageData.catalogMix.packageOptions
  } else {
    throw new Error('Could not find packageOptions in JS page data.')
  }
}

export default {
  state: {
    selectedOptionProducts: [],
    prohibitedProducts: [],
    packageOptionsModel: resolvePackageOptionsObject()
  },
  mutations: {
    addSelectedOptionProduct: (state, optionProduct) => {
      state.selectedOptionProducts.push(optionProduct)
    },
    removeSelectedOptionProduct: (state, optionProduct) => {
      remove(state.selectedOptionProducts, (selectedOptionProduct) => {
        return selectedOptionProduct.CatalogPackageOptionProductID === optionProduct.CatalogPackageOptionProductID
      })

      state.selectedOptionProducts = [...state.selectedOptionProducts]
    },
    setProhibitedProducts: (state, prohitibitedProductDictionary) => {
      let prohibitedProducts = []

      const selectedOptionProductClassNames = uniq(map(state.selectedOptionProducts, 'ClassName'))

      selectedOptionProductClassNames.forEach(className => {
        if (prohitibitedProductDictionary[className] !== undefined) {
          prohibitedProducts = prohibitedProducts.concat(prohitibitedProductDictionary[className])
        }
      })

      state.prohibitedProducts = uniq(prohibitedProducts)
    }
  },
  getters: {
    subTotalSelectedOptionProducts: (state, getters, rootState) => {
      const packageQuantity = rootState.catalogPageCommon.packageQuantity

      let subTotal = 0

      state.selectedOptionProducts.forEach(sop => {
        if (sop.MatchPackageQty === true) {
          subTotal += (sop.Cost * packageQuantity)
        } else {
          subTotal += sop.Cost
        }
      })

      return subTotal
    },
    getOptionProductIsSelected: state => packageOptionProduct => {
      return find(state.selectedOptionProducts, ['CatalogPackageOptionProductID', packageOptionProduct.CatalogPackageOptionProductID]) !== undefined
    },
    getOptionProductIsDisabled: (state, getters, rootState) => packageOptionProduct => {
      if (rootState.catalogPageCommon.firstOptionProduct.ClassName === 'LetterJackets.SleevePatch' && rootState.letterJackets.selectedPatch !== null) {
        if (rootState.letterJackets.selectedPatch.SupportsColorBurst === false && packageOptionProduct.ClassName === 'LetterJackets.ColorBurstUpgrade') {
          return true
        }

        if (rootState.letterJackets.selectedPatch.SupportsSportTouch === false && packageOptionProduct.ClassName === 'LetterJackets.SportTouchUpgrade') {
          return true
        }

        // These two can be null, so check that it is not true instead
        if (rootState.letterJackets.selectedPatch.SupportsSwissInsert !== true && packageOptionProduct.ClassName === 'LetterJackets.SwissInsert') {
          return true
        }

        if (rootState.letterJackets.selectedPatch.SupportsChenilleActivitySymbol !== true && packageOptionProduct.ClassName === 'LetterJackets.ChenilleActivitySymbol') {
          return true
        }
      }

      return state.prohibitedProducts.indexOf(packageOptionProduct.ClassName) > -1
    },
    getConfigurableOptionProducts: state => {
      return orderBy(filter(state.selectedOptionProducts, (sop) => {
        return sop.LetterJacketProductCaptions !== undefined && sop.LetterJacketProductCaptions !== null && sop.LetterJacketProductCaptions.length > 0
      }), 'zOrder')
    },
    getSelectedOptionProductsByCatalogPackageOption: state => catalogPackageOptionId => {
      return filter(state.selectedOptionProducts, ['catalogPackageOptionId', catalogPackageOptionId])
    }
  },
  actions: {
    addSelectedOptionProduct ({ commit, rootState }, { optionProduct, zOrder }) {
      const optionProductWithZorder = { ...optionProduct, zOrder }

      commit('addSelectedOptionProduct', optionProductWithZorder)

      commit('setProhibitedProducts', rootState.catalogPageCommon.offerPackage.ProhibitedProductDictionary)
    },
    addOneSelectedOptionProductPerCatalogPackageOption ({ state, commit, rootState }, { optionProduct, catalogPackageOptionId, zOrder }) {
      const optionProductWithCatalogPackageOptionId = { ...optionProduct, catalogPackageOptionId, zOrder }

      filter(state.selectedOptionProducts, ['catalogPackageOptionId', catalogPackageOptionId]).forEach(sop => {
        commit('removeSelectedOptionProduct', sop)
      })

      commit('addSelectedOptionProduct', optionProductWithCatalogPackageOptionId)

      commit('setProhibitedProducts', rootState.catalogPageCommon.offerPackage.ProhibitedProductDictionary)
    },
    removeSelectedOptionProduct ({ commit, state, rootState }, { packageOptionProduct }) {
      commit('removeSelectedOptionProduct', packageOptionProduct)
      commit('setProhibitedProducts', rootState.catalogPageCommon.offerPackage.ProhibitedProductDictionary)
    }
  }
}



// WEBPACK FOOTER //
// ./WebResources/vue/shared/stores/optionProducts.js